<mat-menu #childMenu="matMenu" [overlapTrigger]="false">
  @for (item of items; track item) {
    <ng-template matMenuContent [ngForOf]="items" let-item>
      @if (item.name && (!item.children || item.children.length === 0)) {
        <a
          mat-menu-item
          [routerLink]="item.routerLink"
          [queryParamsHandling]="item.queryParamsHandling"
          routerLinkActive="active-page"
          [matTooltip]="item.tooltip"
          matTooltipPosition="right"
          >
          @if (item.icon) {
            <mat-icon>{{ item.icon }}</mat-icon>
          }
          <span>{{ item.name }}</span>
        </a>
      } @else {
        @if (item.name) {
          <button
            mat-menu-item
            class="nav-item"
            type="button"
            [matMenuTriggerFor]="menu.childMenu"
            [matMenuTriggerData]="{ $implicit: item.children }"
            [ndtRouteArea]="item.area"
            ndtRouteAreaActive="active-page"
            [matTooltip]="item.tooltip"
            matTooltipPosition="right"
            >
            @if (item.icon) {
              <mat-icon>{{ item.icon }}</mat-icon>
            }
            <span>{{ item.name }}</span>
          </button>
        }
        <ndt-nested-menu #menu [items]="item.children"></ndt-nested-menu>
      }
    </ng-template>
  }
</mat-menu>
